import { render, staticRenderFns } from "./TitleBadge.vue?vue&type=template&id=68202d0c"
import script from "./TitleBadge.vue?vue&type=script&lang=js"
export * from "./TitleBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports